import { Attribute, Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';


@Directive({
    selector: '[xform-validate-equal][formControlName],[xform-validate-equal][formControl],[xform-validate-equal][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidator), multi: true }
    ],
    standalone: false
})
export class EqualValidator implements Validator {
  constructor(@Attribute('xform-validate-equal') public validated: string) {}

  validate(c: AbstractControl): Record<string, any> {
    // self value (e.g. retype password)
    const v = c.value;

    // control value (e.g. password)
    const e = c.root.get(this.validated);

    // value not equal
    if (e && v !== e.value) {
      return {
        validated: false
      };
    }
    return null;
  }
}
